import { UiKitContextProvider } from '@cian/ui-kit/context';
import { Input } from '@cian/ui-kit/input';
import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import * as styles from './GeoLocationModal.css';

import classnames from 'classnames';

import { NotFound } from './components/NotFound';
import { IRegions } from '../../types/regions';
import { TRegion } from '../../types/geoSwitcher';
import { POPULAR_REGIONS } from '../../constants/popularRegions';

export interface IGeoLocationModalState {
  searchValue: string;
}

type TGeoLocationModalProps = {
  open: boolean | undefined;
  onClose: VoidFunction;
  title: string;
  selectNewRegion: (newRegion: TRegion) => void;
  onSearchValue: (e: React.ChangeEvent<HTMLInputElement>) => void;
  canVisiblePopularRegions: boolean;
  regions: IRegions[] | [];
};

export const GeoLocationModal: React.FC<TGeoLocationModalProps> = ({
  title,
  open,
  onClose,
  selectNewRegion,
  onSearchValue,
  canVisiblePopularRegions,
  regions,
}) => {
  return (
    <UiKitContextProvider deviceType="phone" useStaticDeviceType>
      <ModalWindow
        open={Boolean(open)}
        onClose={onClose}
        title={title}
        content={
          <>
            <div className={styles['input-wrapper']}>
              <Input size="M" placeholder="Поиск" onChange={onSearchValue} />
            </div>
            <div className={styles['container']}>
              <div className={styles['wrapper']}>
                {regions.length === 0 && <NotFound />}
                <div className={styles['lists']}>
                  <div className={classnames(!canVisiblePopularRegions && styles['hidden'])}>
                    <div className={styles['list']} data-name="GeoList">
                      {POPULAR_REGIONS.map((item, index) => (
                        <div
                          onClick={() => selectNewRegion(item)}
                          className={styles['link']}
                          key={`list_${index}_location`}
                        >
                          {item.displayName}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className={styles['list']}>
                      {regions.map((item, index) => (
                        <div
                          className={styles['link']}
                          onClick={() => selectNewRegion(item)}
                          key={`list_location_${index}`}
                        >
                          {item.displayName}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      />
    </UiKitContextProvider>
  );
};
